import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

/**
 * @description Returns a callback that leaves the Avigilon Alta Id / SSO form for the plain
 * login form at loginRoute. It drops only useAltaId -- the param that selects the form being
 * left -- and carries every other query param over.
 *
 * The query string has to survive that navigation. redirectUrl lives in it, is read off the
 * live url on every render (see useAltaLoginUrlParams) and is what getSsoAuthUrl sends to
 * helium as the post-login destination. navigate('/signin') with a bare path string replaces
 * the whole location, query string included, so pressing this button used to leave
 * redirectUrl empty and the user landed on the Alta portal instead of the app that sent them.
 */
export const useNavigateToLoginRoute = (loginRoute: '/login' | '/signin') => {
  const location = useLocation();
  const navigate = useNavigate();

  return () => {
    const queryParams = new URLSearchParams(location.search);
    queryParams.delete('useAltaId');
    navigate({ pathname: loginRoute, search: queryParams.toString() });
  };
};
